import styled from 'styled-components';
import { animated } from 'react-spring';

import { size, colors, typography } from '@everlywell/leaves';

export const TabMenuWrapper = styled.div`
  position: relative;
`;

export const Tabs = styled.ul`
  display: flex;
`;

export const Item = styled.li`
  list-style-type: none;
  margin-right: ${size.xl1}px;

  &:last-of-type {
    margin-right: 0;
  }
`;

export const Tab = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: ${colors.green5};
  ${typography.buttonTextSmall};
`;

export const AnimatedActiveIndicator = styled(animated.div)`
  height: 4px;
  background-color: ${colors.teal6};
`;
